// extracted by mini-css-extract-plugin
export default {"rule":"index_rule__BftwO","paragraph":"index_paragraph__pgDME","title":"index_title__y+uTO","content":"index_content__XLONN"};